import React, { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";
import Layout from "../layouts/layout";
import REVIEWS from "../api/services/REVIEWS";
import StatsBar from "../containers/_reviews/statsBar";
import ReviewCard from "../containers/_reviews/reviewCard";
import styles from "../styles/_screens/reviews.module.scss";

export default function Reviews() {
  const [reviews, setReviews] = useState([]);
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const [reviewsRes, statsRes] = await Promise.all([
        REVIEWS.getAll(1),
        REVIEWS.getStats(),
      ]);
      const rData = reviewsRes?.data || reviewsRes;
      const sData = statsRes?.data || statsRes;
      setReviews(rData?.reviews || []);
      setTotal(rData?.total || 0);
      setStats(sData);
    } catch {
      toast.error("שגיאה בטעינת ביקורות");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchData(); }, [fetchData]);

  const handleToggleHide = async (id) => {
    try {
      const res = await REVIEWS.toggleHide(id);
      const updated = res?.data?.review || res?.review;
      setReviews(prev => prev.map(r => r._id === id ? { ...r, isHidden: updated?.isHidden ?? !r.isHidden } : r));
      toast.success(updated?.isHidden ? "הביקורת הוסתרה" : "הביקורת מוצגת");
    } catch {
      toast.error("שגיאה בעדכון");
    }
  };

  const loadMore = async () => {
    const next = page + 1;
    try {
      const res = await REVIEWS.getAll(next);
      const data = res?.data || res;
      setReviews(prev => [...prev, ...(data?.reviews || [])]);
      setPage(next);
    } catch {
      toast.error("שגיאה בטעינה");
    }
  };

  if (loading) {
    return (
      <Layout>
        <div className={styles.container}>
          <div className={styles.loaderWrap}><div className={styles.loader} /></div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.pageHeader}>
          <h1 className={styles.pageTitle}>ביקורות</h1>
          <p className={styles.pageSubtitle}>ניהול ביקורות ודירוגים</p>
        </div>

        <StatsBar stats={stats} />

        {reviews.length === 0 ? (
          <div className={styles.empty}><p>אין ביקורות עדיין</p></div>
        ) : (
          <>
            {reviews.map(r => (
              <ReviewCard key={r._id} review={r} onToggleHide={handleToggleHide} />
            ))}
            {reviews.length < total && (
              <button className={styles.loadMoreBtn} onClick={loadMore}>הצג עוד</button>
            )}
          </>
        )}
      </div>
    </Layout>
  );
}
